import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { Package, Truck } from 'lucide-react';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const ChatBubble = styled(motion.div)`
  width: 280px;
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  position: relative;
`;

const ProductCard = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`;

const ProductImage = styled.div`
  width: 48px;
  height: 48px;
  background: #e5e7eb;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
`;

const ProductInfo = styled.div`
  flex: 1;
`;

const ProductName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 4px;
`;

const OrderStatus = styled.div`
  font-size: 12px;
  color: #10b981;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const WooCommerceVisual: React.FC = () => {
    return (
        <Container>
            <ChatBubble
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
            >
                <div style={{ fontSize: '14px', color: '#374151', marginBottom: '8px' }}>
                    Here is the status of your recent order:
                </div>

                <ProductCard>
                    <ProductImage>
                        <Package size={24} />
                    </ProductImage>
                    <ProductInfo>
                        <ProductName>Premium Plan</ProductName>
                        <OrderStatus>
                            <Truck size={12} />
                            Out for delivery
                        </OrderStatus>
                    </ProductInfo>
                </ProductCard>

                {/* TODO: Add a public status label only when the integration is ready to launch. */}
            </ChatBubble>
        </Container>
    );
};

export default WooCommerceVisual;
